<template>
  <div class="page">
    <div class="ctrl">
      <a-button type="primary" @click="show_create = true">添加</a-button>
    </div>
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="action" slot-scope="text, record">
        <a-button type="primary" size="small" @click="update(record)"
          >编辑</a-button
        >
        <a-divider type="vertical" />

        <a-popconfirm
          title="确定要删除吗？"
          ok-text="确定"
          cancel-text="取消"
          @confirm="del(record.id)"
        >
          <a-button type="danger" size="small">删除</a-button>
        </a-popconfirm>
      </template>
    </a-table>

    <CreateModal v-if="show_create" :exh_id="exh_id" @callback="added" />
    <UpdateModal v-if="show_update" :oldData="oldData" @callback="updated" />
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
import CreateModal from "./create";
import UpdateModal from "./update";

const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  {
    title: "项目",
    dataIndex: "title",
  },
  {
    title: "日期",
    dataIndex: "date",
  },
  {
    title: "开始时间",
    dataIndex: "start_time",
  },
  {
    title: "结束时间",
    dataIndex: "end_time",
  },
  {
    title: "场地",
    dataIndex: "place",
  },
  {
    title: "备注",
    dataIndex: "remarks",
  },
  {
    title: "操作",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export default {
  components: { CreateModal, UpdateModal },
  data() {
    return {
      exh_id: null,
      columns,
      list: [],
      show_create: false,
      show_update: false,
      oldData: {},
    };
  },
  created() {
    this.exh_id = this.$route.query.exh_id;
    this.getList();
  },
  methods: {
    async getList() {
      const r = await this.$axios.get("/exh/calendar/getList", {
        params: {
          exh_id: this.exh_id,
        },
      });
      if (r.status != 1) return;
      this.list = r.list;
    },
    
    async del(id) {
      const r = await this.$axios.post("/exh/calendar/del", {
        id,
      });

      if (r.status == 1) {
        this.getList();
      }
    },

    added(e) {
      this.show_create = false;
      if (e) this.getList();
    },

    update(item) {
      this.oldData = item;
      this.show_update = true;
    },
    updated(e) {
      this.show_update = false;
      if (e) this.getList();
    },

    
  },
};
</script>